import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors } from "src/assets";
import LocalText from "src/local";

export type NotFoundProps = {};

export const NotFound: React.FC<NotFoundProps> = ({}) => {
  return (
    <View style={styles.container}>
      <View style={styles.icon}>
        <svg width="88" height="81.003" viewBox="0 0 88 81.003">
          <path
            d="M647.339,178.987l-1.9-1.362c-.1-.076-10.648-7.66-20.79-16.2-10.064-8.474-21.471-18.079-21.471-35.89,0-14.677,11.749-27.551,25.143-27.551,7.606,0,13.246,2.219,18.726,7.526,4.92-5.118,11.042-7.526,18.989-7.526,13.393,0,25.142,12.874,25.142,27.551,0,17.81-11.406,27.416-21.47,35.89-10.127,8.528-20.389,16.1-20.492,16.178ZM628.323,104.4c-10.716,0-18.723,11.156-18.723,21.131,0,14.824,9.754,23.037,19.186,30.979,7.415,6.244,15.054,11.972,18.505,14.514,3.395-2.556,10.878-8.277,18.284-14.514,9.432-7.943,19.186-16.156,19.186-30.979,0-9.975-8.007-21.131-18.723-21.131-7.218,0-12.24,2.417-16.285,7.837l-2.38,3.19-2.613-3C639.667,106.579,635.212,104.4,628.323,104.4Z"
            transform="translate(-603.18 -97.984)"
            fill="#b2b2b2"
          />
        </svg>
      </View>
      <Text style={styles.text}>
        {LocalText.screens.likedServies.notFound.text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: 31,
    color: colors.black,
    fontSize: 16,
    fontWeight: "bold",
  },
  icon: {},
});
